import { Misc } from '@/utils'
import { ALLOWED_DOMAINS } from '../settings'

export class UserPermissions {
  static hasPermissionsOnDomain(accountDomains) {
    const currentDomain = Misc.getCurrentDomain()
    const allowedDomains = accountDomains
      ? [
        ...ALLOWED_DOMAINS.split(','),
        ...accountDomains.split(',') ]
      : [
        ...ALLOWED_DOMAINS.split(',') ]

    return allowedDomains.some((ad) => currentDomain.replace(/\/$/, '').includes(ad.replace(/\/$/, '')))
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/UserPermissions.ts